/*
 * @Author: ghy
 * @Date: 2023-07-21 16:45:22
 * @LastEditors: ghy
 * @LastEditTime: 2023-07-21 16:46:48
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        searchValue:'',
        gwSearch: {},
    },
    getters: {

    },
    mutations: {
        getSearchValue(state, searchValue) {
            state.searchValue = searchValue;
        },       
        getGwSearch(state, gwSearch) {
            state.gwSearch = gwSearch;
        },
    },
    actions: {
    },
    modules: {
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js